module.exports = require('./helpers/bundle-url').getBundleURL('eot5l') + "checkout.cc97b3de.svg";